<template lang="html">
  <v-layout column>
    <toolbar :title="`My Assigned Loads (${bookedLoads.length})`">
      <v-icon @click="getBookedLoads()">refresh</v-icon>
    </toolbar>

    <div class="pt-3" v-if="$vuetify.breakpoint.mdAndUp">
      <v-card>
        <v-tabs v-model="tab" color="white" grow>
          <v-tabs-slider color="primary" />
          <v-tab key="Scheduled">
            Scheduled ({{scheduledLoads.length}})
          </v-tab>

          <v-tab key="In Transit">
            In Transit ({{inTransitLoads.length}})
          </v-tab>

          <v-tab key="Delivered">
            Delivered ({{deliveredLoads.length}})
          </v-tab>
          <v-tabs-items v-model="tab">
            <v-tab-item key="Scheduled">
              <scheduled-loads
                        disabledRouting
                        :loading-list="loading"
                        @refresh="getBookedLoads()"
                        dispatched
                        :status="loadStatus.SCHEDULED"
                        :loads="scheduledLoads">
              </scheduled-loads>
            </v-tab-item>
            <v-tab-item key="In Transit">
              <scheduled-loads :loads="inTransitLoads"
                               :loading-list="loading"
                               disabledRouting
                               dispatched
                               :status="loadStatus.IN_TRANSIT"
                               @refresh="getBookedLoads()">
              </scheduled-loads>
            </v-tab-item>
            <v-tab-item key="Delivered">
              <scheduled-loads :loads="deliveredLoads"
                               :loading-list="loading"
                               dispatched
                               disabledRouting
                               :status="loadStatus.DELIVERED">
              </scheduled-loads>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </div>

    <div class="pt-3" v-if="$vuetify.breakpoint.smAndDown">

      <v-text-field v-model="search" append-icon="search"
                    class="mb-2 single-line hide-details"
                    label="Search loads">
      </v-text-field>

      <v-select
        :items="mobileSortOptions"
        v-model="sortValue"
        menu-props="auto"
        label="Sort by"
        hide-details
        append-icon="sort"
        single-line
        class="mb-2"
      ></v-select>

      <h2 class="title mobile-title">Scheduled ({{scheduledLoads.length}})</h2>
      <v-card>
        <scheduled-loads
          disabledRouting
          :loading-list="loading"
          dispatched
          @refresh="getBookedLoads()"
          :status="loadStatus.SCHEDULED"
          :loads="scheduledLoads">
        </scheduled-loads>
      </v-card>

      <h2 class="title mobile-title">In Transit ({{inTransitLoads.length}})</h2>
      <v-card>
        <scheduled-loads :loads="inTransitLoads"
                         :loading-list="loading"
                         disabledRouting
                         dispatched
                         @refresh="getBookedLoads()"
                         :status="loadStatus.IN_TRANSIT">
        </scheduled-loads>
      </v-card>

      <h2 class="title mobile-title">Delivered ({{deliveredLoads.length}})</h2>
      <v-card>
        <scheduled-loads :loads="deliveredLoads"
                         :loading-list="loading"
                         disabledRouting
                         dispatched
                         @refresh="getBookedLoads()"
                         :status="loadStatus.DELIVERED">
        </scheduled-loads>
      </v-card>
    </div>
  </v-layout>
</template>

<script>
import API from '@/api';
import _ from 'lodash';

import filterLoads from '@/mixins/filterLoads';
import Toolbar from '@/components/Toolbar';
import ScheduledLoads from '@/components/dashboard/simple/ScheduledLoads';

export default {
  name: 'MyAssignedLoads',
  mixins: [filterLoads],
  data: () => ({
    bookedLoadStep: 0,
    bookedLoads: [],
    loading: false,
    tab: null,
    loadingBtn: false,
    mobileSortOptions: [
      { text: 'Sort ascending by Pickup Date', value: 'pickup_asc' },
      { text: 'Sort descending by Pickup Date', value: 'pickup_desc' },
    ],
  }),
  computed: {
    _() {
      return _;
    },
  },
  components: {
    ScheduledLoads,
    Toolbar,
  },
  methods: {
    async getBookedLoads() {
      try {
        this.bookedLoads = [];
        this.loading = true;
        const apiResponse = await API.user.getMyLoads();

        this.bookedLoads = apiResponse.data.items || [];
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    window.__insp.push(['tagSession', 'open_my_loads']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'my_loads',
    });

    this.getBookedLoads();
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/User/MyAssignedLoads.vue